import { useNavigate, useLocation } from '@tanstack/react-router'
import { Home, BookOpen, ShoppingBag, Calendar, ShoppingCart } from 'lucide-react'
import { BottomNav as BottomNavUI, type BottomNavItem } from '@/shared/ui/bottom-nav'
import { useTelegram } from '@/shared/lib/telegram'
import { useCart } from '@/features/cart'
import { useKeyboardVisible } from '@/shared/lib/use-keyboard-visible'

/**
 * Виджет: Нижняя навигация
 */
export function BottomNav() {
  const navigate = useNavigate()
  const location = useLocation()
  const { hapticFeedback } = useTelegram()
  const { data: cartData } = useCart()
  const cartItemsCount = cartData?.data?.itemsCount ?? 0
  const keyboardVisible = useKeyboardVisible()

  const handleItemClick = (path: string) => {
    hapticFeedback.impactOccurred('light')
    navigate({ to: path as any })
  }

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/'
    }
    return location.pathname.startsWith(path)
  }

  const navItems: BottomNavItem[] = [
    {
      id: 'home',
      icon: Home,
      label: 'Главная',
      active: isActive('/'),
      onClick: () => handleItemClick('/'),
    },
    {
      id: 'diary',
      icon: BookOpen,
      label: 'Дневник',
      active: isActive('/tea-diary'),
      onClick: () => handleItemClick('/tea-diary'),
    },
    {
      id: 'catalog',
      icon: ShoppingBag,
      label: 'Каталог',
      active: isActive('/catalog'),
      onClick: () => handleItemClick('/catalog/tea'),
    },
    {
      id: 'events',
      icon: Calendar,
      label: 'События',
      active: isActive('/events'),
      onClick: () => handleItemClick('/events'),
    },
    {
      id: 'cart',
      icon: ShoppingCart,
      label: 'Корзина',
      active: isActive('/cart'),
      onClick: () => handleItemClick('/cart'),
      showBadge: cartItemsCount > 0,
      badgeCount: cartItemsCount,
    },
  ]

  if (keyboardVisible) return null

  return <BottomNavUI items={navItems} />
}
